import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Col } from 'antd'
import { RightOutlined } from '@ant-design/icons'

import { Material } from '@types'

import {
  StyledContainer,
  StyledRowMobile,
  StyledButton,
  StyledTitle,
  StyledAutocomplete,
} from '../components'
import { FormValidation } from './validations/validations'

type MaterialProps = {
  nextStep: () => void
  materialOptions: Material[] | undefined
  // eslint-disable-next-line @typescript-eslint/ban-types
  control: Control<FormValidation, object>
}

export const Materials: React.FC<MaterialProps> = ({ nextStep, materialOptions, control }) => {
  const { t } = useTranslation()

  return (
    <StyledContainer>
      <StyledTitle>Seleccionar tipo de material</StyledTitle>
      <Controller
        name="materialId"
        control={control}
        render={({ field }) => (
          <>
            <StyledAutocomplete
              {...field}
              placeholder={t('form_mobile.material')}
              options={materialOptions?.map(material => ({
                label: material.nameShort,
                value: material.nameShort,
              }))}
              dropdownMatchSelectWidth={250}
              filterOption={(inputValue, option) =>
                option!.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
              style={{ width: 250 }}
            />
          </>
        )}
      />
      <StyledRowMobile>
        <Col>
          <StyledButton
            style={{ backgroundColor: '#579c5f', border: 'none', color: 'white', marginTop: '5px' }}
            onClick={() => nextStep()}
          >
            Seleccionar camión
            <RightOutlined />
          </StyledButton>
        </Col>
      </StyledRowMobile>
    </StyledContainer>
  )
}
